import React, { Component } from 'react';
import { BrowserRouter as Router, Link } from 'react-router-dom';
import ScrollToTopRoute from './components/router-ext/scrollToTopRoute';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import { Home, Press, Imprint } from './routes';
import SubscriptionModal from './components/modals/subscriptionModal/subscriptionModal';
import Icons from './utilities/js/icons';
import logo from './logo.svg';
import './App.css';

class Navigation extends Component {
  constructor() {
    super();
    this.state = {
      isCollapsed: true,
    }
  }

  handleToggle = () => {
    const { isCollapsed } = this.state;
    this.setState({ isCollapsed: !isCollapsed });
  }

  handleCollapse = () => {
    this.setState({ isCollapsed: true });
  }

  render() {
    const { isCollapsed } = this.state;
    const clsUl = isCollapsed ? '' : 'expanded';
    const clsToggleInput = isCollapsed ? '' : 'expanded';
    const NavItem = (props) => {
      const { to, content } = props;
      return(
        <li>
          <NavLink
            smooth
            to={to}
            onClick={this.handleCollapse}
          >
            {content}
          </NavLink>
        </li>
      )
    };
    return(
      <nav>
        <ul className={clsUl}>
          <NavItem to="/#about" content="About" />
          <NavItem to="/#photos" content="Photos" />
          <NavItem to="/#events" content="Past events" />
          <NavItem to="/#contact" content="Contact" />
          <NavItem to="/press" content="Press" />
          <li><SubscriptionModal /></li>
        </ul>
        <button className="nav-toggle">
          <input
            id="nav-burger"
            type="checkbox"
            className={clsToggleInput}
            onClick={this.handleToggle}
          />
          <label htmlFor="nav-burger"></label>
        </button>
      </nav>
    );
  }
}

const Footer = () => {
  return(
      <footer>
        <div>
          <img className="logo" src={logo} alt="porno&piano" />
        </div>
        <div>
          You can follow us on
          <a
            className="social-link"
            href="https://fb.me/pornpiano"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button><Icons.Social.Facebook /></button>
          </a>
        </div>
        <div>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/press">Press</Link></li>
            <li><Link to="/imprint">Imprint</Link></li>
          </ul>
        </div>
        <div>&copy; 2019 Porno &amp; Piano</div>
      </footer>
  );
}

class App extends Component {
  componentDidMount(){
    document.title = "PORNO UND PIANO";
  }

  render() {
    return (
      <Router onUpdate={this.handleUpdate}>
        <main>
          <Navigation />
          <ScrollToTopRoute exact path="/" component={Home} />
          <ScrollToTopRoute exact path="/press" component={Press} />
          <ScrollToTopRoute exact path="/imprint" component={Imprint} />
          <Footer />
        </main>
      </Router>
    );
  }
}

export default App;
